import { render, staticRenderFns } from "./RecModal.vue?vue&type=template&id=6ce50993&"
import script from "./RecModal.vue?vue&type=script&lang=js&"
export * from "./RecModal.vue?vue&type=script&lang=js&"
import style0 from "./RecModal.vue?vue&type=style&index=0&id=6ce50993&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports